import React from "react";
import * as S from "./ToastProvider.css";

const ToastProvider = () => {
  return <S.Toast autoClose={4000} hideProgressBar />;
};

export default ToastProvider;
